// extracted by mini-css-extract-plugin
module.exports = {"button_inner":"SpinnerButton_button_inner__32sUY","spinner_container":"SpinnerButton_spinner_container__3wtzk"};